// extracted by mini-css-extract-plugin
module.exports = {"session":"board_edit_session__3VjoI","form":"board_edit_form__2O6DZ","title":"board_edit_title__1mcdd","content":"board_edit_content__2smGG","btn":"board_edit_btn__3-Mbs"};